import * as axios from "axios";
import { ContentAPI, MembershipAPI,FooterAPI } from "../shared/config";

const getFooterNav = async function() {
  try {
    const response = await axios.get(`${FooterAPI}/GetFooterNavigation`);
    return response.data;
  } catch (error) {
    console.log(error);
    return [];
  }
};
const getSatContent = async function() {
  try {
    const response = await axios.get(
      `${ContentAPI}/GetAllSelfAssessmentToolsContent`
    );
    if (!response.data)
      throw Error("Content API response data null or undefined.");
    return response.data;
  } catch (error) {
    console.log(error);
    return {};
  }
};
const getContent = async function() {
  try {
    const response = await axios.get(
      `${ContentAPI}/GetSelfAssessmentToolsContent`
    );
    if (!response.data)
      throw Error("Content API response data null or undefined.");
    return response.data;
  } catch (error) {
    console.log(error);
    return {};
  }
};
const getSatSavedData = async function(satId) {
  try {
    const response = await axios.get(`${ContentAPI}/GetSelfAssessmentTool`, {
      params: { satId }
    });
    return response.data;
  } catch (error) {
    console.log(error);
    return {};
  }
};

const getNotificationsData = async function() {
  try {
    const response = await axios.get(`${ContentAPI}/GetNotifications`);
    return response.data;
  } catch (error) {
    console.log(error);
    return {};
  }
};

const saveViewedNotification = async function(notificationId) {
  try {
    const response = await axios.post(
      `${ContentAPI}/SaveViewedNotification`,
      notificationId,
      { headers: { "Content-Type": "application/json" } }
    );
    return response;
  } catch (error) {
    console.log(error);
    return {};
  }
};

const saveAssessments = async function(satContent) {
  try {
    const response = await axios.put(`${ContentAPI}/SaveAssessments`, satContent, { headers: { 'Content-Type': 'application/json' }});
    return response;
  } catch (error) {
    console.error(error);
    return null;
  }
};

const deleteAssessmentResponses = async function(satId) {
  try {
    const response = await axios.post(`${ContentAPI}/DeleteAssessmentResponses?satId=${satId}`);
    return response;
  } catch (error) {
    console.error(error);
    return null;
  }
};

const createUser = async function(user) {
  try {
    const response = await axios.post(
      `${MembershipAPI}/createuser`,
      JSON.stringify(user)
    );
    const createdUser = parseItem(response.data, 201);
    return createdUser;
  } catch (error) {
    console.error(error);
    return null;
  }
};
const updateUser = async function(user,section) {
 // try {
    const response = await axios.post(`${MembershipAPI}/update?section=${section}`, user);
    const updatedUser = parseItem(response, 200);
    return updatedUser;
  // } catch (error) {
  //   console.log(error);
  //   return null;
  // }
};
const logoutAndDeleteUser = async function() {
  const response = await axios.get(`${MembershipAPI}/LogoutAndDeleteUser`);
  return response;
};
const signin = async function(username, password) {
  const response = await axios.post(`${MembershipAPI}/login`, {
    username,
    password
  });
  let data = parseItem(response, 200);
  return data;
  // } catch (error) {
  //   return null;
  // }
};
const signout = async function() {
  // try {
  const response = await axios.get(`${MembershipAPI}/logout`);
  return response;
  // } catch (error) {
  //   console.error(error);
  //   return null;
  // }
};
const resetPassword = async function(password,key) {
  //try {
  const response = await axios.post(`${MembershipAPI}/resetpassword?key=${key}`, {
    NewPassword : password
  });
  console.log(response);
  return response;
  // } catch (error) {
  //   console.error(error);
  //   return null;
  // }
};
const verifyAccount = async function(key) {
  //try {
  const response = await axios.post(`${MembershipAPI}/VerifyAccount?key=${key}`);
  console.log(response);
  return response;
  // } catch (error) {
  //   console.error(error);
  //   return null;
  // }
};
const forgotPassword = async function(username) {
  const response = await axios.post(
    `${MembershipAPI}/ForgotPassword`,
    { EmailAddress: username },
    {
      headers: {
        "content-type": "application/json"
      }
    }
  );
  return response;
};
const getUsername = async function(key) {
  try {
     const response = await axios.post(`${MembershipAPI}/GetUsername?key=${key}`
    );
    return parse(response,200);
  } catch (error) {
    console.log(error);
    return {};
  }
};
const register = async function(user) {
  //try {

  const response = await axios.post(
    `${MembershipAPI}/register`,
    JSON.stringify(user),
    {
      headers: {
        "content-type": "application/json"
      }
    }
  );

  return parseItem(response, 201);
  // } catch (error) {
  //   console.log(error);
  //   return null;
  // }
};

const authenticateUser = async function() {
  // try {
  const response = await axios.get(`${MembershipAPI}/MemberAuthentication`);
  return response;
  // } catch (error) {
  //   console.error(error);
  //   return null;
  // }
};

/* const parseList = response => {
  if (response.status !== 200) throw Error(response.message);
  if (!response.data) return [];
  let list = response.data;
  if (typeof list !== "object") {
    list = [];
  }
  return list;
}; */
export const parse = (response, code) => {
  if (response.status !== code) throw Error(response.message);
  let item = response.data;
  // if (typeof item !== "object") {
  //   item = undefined;
  // }
  return item;
};
export const parseItem = (response, code) => {
  if (response.status !== code) throw Error(response.message);
  let item = response.data;
  if (typeof item !== "object") {
    item = undefined;
  }
  return item;
};
const errorResponseHandler = error => {
  //Setup Error Message
  if (typeof error !== "undefined") {
    //Try to Use the Response Message
    if (
      Object.prototype.hasOwnProperty.call(error, "response") &&
      Object.prototype.hasOwnProperty.call(error.response, "data")
      // error.hasOwnProperty("response") &&
      // error.response.hasOwnProperty("data")
    ) {
      if (
        Object.prototype.hasOwnProperty.call(error.response.data, "message") &&
        //error.response.data.hasOwnProperty("message") &&
        error.response.data.message.length > 0
      ) {
        return error.response.data.message;
      }
    }

    if (Object.prototype.hasOwnProperty.call(error, "message")) {
      //if (error.hasOwnProperty("message")) {
      return error.message;
    }
  }

  if (typeof error.response !== "undefined") {
    //Setup Generic Response Messages
    if (error.response.status === 401) {
      return "UnAuthorized";
      // vm.$emit("logout"); //Emit Logout Event
    } else if (error.response.status === 404) {
      return "API Route is Missing or Undefined";
    } else if (error.response.status === 405) {
      return "API Route Method Not Allowed";
    } else if (error.response.status === 422) {
      //Validation Message
    } else if (error.response.status >= 500) {
      return "Server Error";
    }
  }
};
export const dataService = {
  createUser,
  updateUser,
  logoutAndDeleteUser,
  signin,
  signout,
  resetPassword,
  register,
  forgotPassword,
  getSatSavedData,
  getSatContent,
  getNotificationsData,
  saveViewedNotification,
  
  errorResponseHandler,
  getFooterNav,
  getUsername,
  getContent,
  saveAssessments,
  verifyAccount,
  authenticateUser,
  deleteAssessmentResponses
};
